import React, { Fragment, memo, type PropsWithChildren } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';

const BaseIssueOperations = importCond<
	typeof import('@atlassian/jira-issue-navigator-issue-operations/src/ui/index.tsx'),
	typeof import('@atlassian/jira-issue-navigator-issue-operations/src/ui/async.tsx')
>(
	'empanada_nin_convert_issue_ops_to_entrypoint',
	'@atlassian/jira-issue-navigator-issue-operations/src/ui/index.tsx',
	'@atlassian/jira-issue-navigator-issue-operations/src/ui/async.tsx',
);

const MaybeUFOSegment = componentWithFG(
	'nin_blindspot_fixes_fy26',
	({ children }: PropsWithChildren<{}>) => (
		<UFOSegment name="issue-cell-issue-operations" mode="list">
			{children}
		</UFOSegment>
	),
	Fragment,
);

type Props = {
	issueKey: string;
	workType?: string | null;
	issueId: number;
	isCreateSubTaskAllowed?: boolean;
	onIssueRefetch?: (issueKey: string) => void;
	onIssueDelete?: (issueKey: string) => void;
};

export const IssueOperations = memo<Props>(
	({
		issueKey,
		issueId,
		workType,
		onIssueRefetch,
		onIssueDelete,
		isCreateSubTaskAllowed,
	}: Props) => (
		<ButtonWrapper>
			<MaybeUFOSegment>
				<BaseIssueOperations
					issueId={issueId}
					issueKey={issueKey}
					workType={workType}
					isCreateSubTaskAllowed={isCreateSubTaskAllowed}
					onIssueRefetch={onIssueRefetch}
					onIssueDelete={onIssueDelete}
				/>
			</MaybeUFOSegment>
		</ButtonWrapper>
	),
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonWrapper = styled.div({
	backgroundColor: token('color.background.neutral.subtle'),
	borderRadius: token('radius.small'),
	width: 'fit-content',
	marginLeft: 'auto',
});
